import { DiscoverItemCard } from 'utils/gloo-types';
import MultiCarousel from 'components/molecules/MultiCarousel';
import DiscoverCardPreview from 'pages/_AdminAuthoringPages/_components/DiscoverCardPreview';

interface DiscoverCarouselProps {
  itemCards: DiscoverItemCard[];
  onClick: (discoverItemCard: DiscoverItemCard) => void;
}

const DiscoverCarouselPreview = ({ itemCards, onClick }: DiscoverCarouselProps) => {
  const responsive = {
    xxxl: {
      breakpoint: { max: 9999, min: 1250 },
      items: 4,
      partialVisibilityGutter: 0,
    },
    xxl: {
      breakpoint: { max: 1250, min: 1150 },
      items: 3.2,
      partialVisibilityGutter: 60,
    },
    xl: {
      breakpoint: { max: 1150, min: 1024 },
      items: 3,
      partialVisibilityGutter: 60,
    },
    lg: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      partialVisibilityGutter: 60,
    },
    sm: {
      breakpoint: { max: 768, min: 0 },
      items: 1.1,
      partialVisibilityGutter: 60,
    },
  };

  const cards = itemCards.map((item) => (
    <DiscoverCardPreview className="w-full px-2 pb-8 h-full" key={`${item.itemId}`} itemCard={item} onClick={onClick} />
  ));
  return <MultiCarousel items={cards} responsiveObject={responsive} width="100vw - 5.5rem" />;
};

export default DiscoverCarouselPreview;
